module.exports = __webpack_public_path__ + "static/media/arrow-left-orange.e36f2343.svg";